import React from 'react';

/**
 * LoadingSpinner - Reusable loading spinner component
 * 
 * @param {string} size - Size variant: 'sm', 'md', 'lg'
 * @param {string} message - Optional loading message
 * @param {boolean} fullHeight - Whether to take full height
 */
const LoadingSpinner = ({ size = 'md', message, fullHeight = true }) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${fullHeight ? 'h-64' : ''}`}>
      <div
        className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]}`}
        style={{ borderColor: "var(--app-primary-color, #26256b)" }}
      />
      {message && (
        <p className="text-gray-600 mt-4">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
